import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Container, Loader, Stack, Text } from '@mantine/core';

export default function LineCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleCallback = async () => {
      const code = searchParams.get('code');
      const state = searchParams.get('state');

      if (!code || !state) {
        console.error('Missing code or state');
        navigate('/');
        return;
      }

      try {
        // stateをパースしてユーザータイプを取得
        const { userType } = JSON.parse(state);

        const response = await fetch(`${import.meta.env.VITE_API_URL}/api/auth/line/callback`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ code, state }),
        });

        if (!response.ok) {
          throw new Error('認証に失敗しました');
        }

        const data = await response.json();
        
        // トークンを保存
        localStorage.setItem('token', data.token);
        
        // ユーザータイプに応じてリダイレクト
        if (userType === 'admin') {
          navigate('/enlightadmin/dashboard');
        } else {
          navigate('/staff/dashboard');
        }
      } catch (error) {
        console.error('Error during LINE callback:', error);
        navigate('/');
      }
    };

    handleCallback();
  }, [navigate, searchParams]);

  return (
    <Container size="sm" py="xl">
      <Stack align="center" gap="md">
        <Loader size="lg" />
        <Text>認証中...</Text>
      </Stack>
    </Container>
  );
} 